import { render, staticRenderFns } from "./topicListDetails.vue?vue&type=template&id=5a1d11b0&scoped=true"
import script from "./topicListDetails.vue?vue&type=script&lang=js"
export * from "./topicListDetails.vue?vue&type=script&lang=js"
import style0 from "./topicListDetails.vue?vue&type=style&index=0&id=5a1d11b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1d11b0",
  null
  
)

export default component.exports